import { Box, Heading, Image, Text, Stack } from "@chakra-ui/react";
import logo from "../../assets/logo/logo_wobble.png";

export const BlogHeader = () => {
  return (
    <Stack
      spacing={{ base: 4, md: 6 }}
      mb={{ base: 10, md: 16 }}
      align="center"
      textAlign="center"
    >
      <Box
        as="a"
        href="https://wobble.hu"
        target="_blank"
        rel="noopener noreferrer"
        display="block"
        mt={10}
      >
        <Image
          src={logo}
          alt="Wobble logó"
          h={{ base: 6, md: 8 }}
          maxW={{ base: "180px", md: "240px" }}
          mx="auto"
        />
      </Box>

      <Box w="64px" h="2px" borderRadius="full" bg="#007188" opacity={0.8} />

      <Heading
        as="h1"
        fontSize={{ base: "4xl", md: "5xl" }}
        fontWeight="700"
        letterSpacing="-0.03em"
        color="#024856"
        lineHeight="1.05"
      >
        Blog
      </Heading>

      <Text
        maxW="520px"
        fontSize={{ base: "md", md: "lg" }}
        color="#024856"
        opacity={0.8}
      >
        Nálunk nincs zsákbamacska. Blogcikkeinkkel szeretnénk megkönnyíteni azok
        dolgát, akik időpontfoglaló rendszert és online megjelenést keresnek
        vállalkozásukhoz.{" "}
      </Text>
    </Stack>
  );
};

export default BlogHeader;
